<template>
  <div style="height: 100vh; width: 100vm" class="message-chat">
    <div style="height: 10%; width: 100%; min-height: 100px">
      <el-row :gutter="20" style="height: 100%;" type="flex" justify="center" align="middle">
        <el-col :span="20" style="height: 100%; border: 1px solid black; ">
          <el-row style="height: 100%; font-weight: bold; font-size: 24px; " type="flex" justify="center"
                  align="middle">
            <span style="width: 100%">聊天记录
            <br/>
              <span style="font-size: 14px" v-if="jyxRtcLoginOptions">({{`用户id：${jyxRtcLoginOptions.userId}  /用户姓名：${JSON.parse(jyxRtcLoginOptions.userExtInfo).userName} /所在部门：${JSON.parse(jyxRtcLoginOptions.userExtInfo).departmentName}`}})</span>
            </span>
          </el-row>
        </el-col>
        <el-col :span="4" style="height: 100%; border: 1px solid black; ">
          <el-row style="height: 100%; font-weight: bold; font-size: 24px; " type="flex" justify="center"
                  align="middle">在线用户列表
            <br/>
            ({{onlineUsers.length}})
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div style="height: 75%; width: 100%;">
      <el-row :gutter="20" style="height: 100%;">
        <el-col :span="20" style="height: 100%; border: 1px solid black; overflow-y: auto; padding-bottom: 40px"
                id="userMessageElement">
          <el-row v-for="(userMessage,index) in userMessageList" style="margin-top: 10px;" :key="'userMessage_'+index">
            <el-row type="flex" :justify="jyxRtcLoginOptions.userId === userMessage.sourceUserId?'end':'start'"
                    align="middle" style="width: 100%">
              <el-card style="max-width: 70%; color: white; font-size: 18px; font-weight: normal"
                       body-style="padding: 10px"
                       :style="jyxRtcLoginOptions.userId === userMessage.sourceUserId?'float: right; background-color: #67C23A':'float: left; background-color: #409EFF'">
                <div style="word-wrap:break-word; text-align: left">{{userMessage.message}}</div>
              </el-card>
            </el-row>
            <el-row type="flex" :justify="jyxRtcLoginOptions.userId === userMessage.sourceUserId?'end':'start'"
                    align="middle" style="font-size: 10px;margin-top: 5px; color: #8c939d">
              {{jyxRtcLoginOptions.userId === userMessage.sourceUserId?("我对"+
              userMessage.targetUserExtInfo.userName+"说")
              :(userMessage.sourceUserExtInfo.userName+"对我说") }}&nbsp;&nbsp;
            </el-row>
            <el-row type="flex" :justify="jyxRtcLoginOptions.userId === userMessage.sourceUserId?'end':'start'"
                    align="middle" style="font-size: 10px;margin-top: 5px; color: #8c939d; margin-bottom: 20px">
              {{dateFormat(userMessage.time)}}&nbsp;&nbsp;
            </el-row>
          </el-row>
        </el-col>
        <el-col :span="4" style="height: 100%; border: 1px solid black; padding: 0">
          <el-row>
            <i class="el-icon-refresh-right" style="float: right; margin: 10px 20px 10px auto"
               @click="getOnlineUsers(true)"></i>
          </el-row>
          <el-row style="height: calc(100% - 40px); font-weight: bold; font-size: 24px; overflow-y: auto; width: 100%"
                  type="flex"
                  justify="center">
            <el-checkbox-group v-model="checkedUsers" @change="handleCheckedUsersChange" style="width: 100%">
              <el-row v-for="(onlineUser,index) in onlineUsers" :key="'user_'+index" style="margin-top: 10px">
                <el-checkbox :label="onlineUser.userId"
                             style="float: left">{{onlineUser.userExtInfo.userName}}
                </el-checkbox>
              </el-row>
            </el-checkbox-group>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div style="height: 15%; width: 100%;">
      <el-row :gutter="20" style="height: 100%;" type="flex" justify="center" align="middle">
        <el-col :span="20" style="height: 100%; border: 1px solid black; ">
          <el-row style="height: 100%; font-weight: bold; font-size: 24px; " type="flex" justify="center"
                  align="middle">
            <el-input v-model="message" style="margin-right: 40px" clearable></el-input>
            <el-button @click="sendMessageHandle ()">发送</el-button>
            <el-button @click="()=>{joinRoomDialogVisible = true}">进入房间</el-button>
            <el-button @click="logout({userId:checkedUsers[0],message:message})">登出</el-button>
          </el-row>
        </el-col>
        <el-col :span="4" style="height: 100%; border: 1px solid black; ">
          <el-row style="height: 100%; font-weight: bold; font-size: 24px; " type="flex" justify="center"
                  align="middle">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
            </el-checkbox>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="进入房间"
      :close-on-click-modal="false"
      :visible.sync="joinRoomDialogVisible"
      style="max-height: 100%">
      <el-form ref="form" :model="joinRoomForm" label-width="80px" style="width: 100%">
        <el-form-item label="房间id">
          <el-input v-model="joinRoomForm.roomId" placeholder="房间id" clearable></el-input>
        </el-form-item>
        <el-form-item label="房间密码">
          <el-input v-model="joinRoomForm.roomPassword" placeholder="房间密码，没有可不填" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="el-dialog__footer">
      <span slot="footer" class="dialog-footer">
        <el-button @click="()=>{joinRoomDialogVisible = false}">取消</el-button>
        <el-button type="primary" @click="joinRoom(joinRoomForm.roomId,joinRoomForm.roomPassword)">确定</el-button>
      </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {eventNameConstants, jyxRtcConstants} from "../util/Constants.js";
import {init} from "../js/rtcEngine.min.js";
import {showErrorMessage} from "../util/index.js";
import Moment from "moment";

export default {
    data() {
        return {
            pageName: "message",
            jyxRtcLoginOptions: null,
            rtcEngine: null,
            onLineUserMapByUserId: null,
            userMessageElement: null,
            userMessageList: [],
            checkedUsers: [],
            checkAll: false,
            isIndeterminate: false,
            message: "hello",
            joinRoomDialogVisible: false,
            joinRoomForm: {
                roomId: Math.floor(Math.random() * 1000) + "",
                roomPassword: ""
            },
            isRefreshPage: false
        };
    },
    watch: {
        userMessageList: function () {
            this.$nextTick(() => {
                if (this.userMessageElement && this.userMessageElement.autoScrollBottom) {
                    this.userMessageElement.scrollTop = this.userMessageElement.scrollHeight;
                }
            });
        }
    },
    computed: {
        onlineUsers: {
            get () {
                return this.$store.state.common.onlineUsers;
            },
            set (val) {
                this.$store.commit("common/updateOnlineUsers", val);
            }
        }
    },
    created() {
        console.log(this.pageName + " created");
        if (sessionStorage.getItem(jyxRtcConstants.JYX_RTC_BEFORE_PAGE_NAME) === this.pageName) {
        //  刷新
            this.isRefreshPage = true;
        } else {
            sessionStorage.setItem(jyxRtcConstants.JYX_RTC_BEFORE_PAGE_NAME, this.pageName);
        }
    },
    mounted() {
        console.log(this.pageName + " mounted");
        this.jyxRtcLoginOptions = JSON.parse(sessionStorage.getItem(jyxRtcConstants.JYX_RTC_LOGIN_OPTIONS));
        if (!this.jyxRtcLoginOptions) {
            this.$message({
                type: "error",
                message: "登陆已失效，请重新登录!",
                duration: 1500
            });
            this.goto({path: "login"});
            return;
        }
        this.init();
        // 消息订阅
        this.subscribeEventHandle();
        if (this.isRefreshPage) {
            this.isRefreshPage = false;
            // 返回登陆页
            this.goto({path: "login"});
        } else {
        // 正常登录
            this.getOnlineUsers();
        }

        // userMessage窗口处理，但鼠标在该窗口时，禁用滚动到最下层逻辑
        this.userMessageElement = document.getElementById("userMessageElement");
        this.userMessageElement.onmouseenter = () => {
            this.userMessageElement.autoScrollBottom = false;
        };
        this.userMessageElement.onmouseleave = () => {
            this.userMessageElement.autoScrollBottom = true;
        };
    },
    beforeDestroy() {
        console.log(this.pageName + " beforeDestroy");
    },
    methods: {
        goto({path, query}) {
            if (path === "login" && this.rtcEngine) {
                sessionStorage.removeItem(jyxRtcConstants.JYX_RTC_LOGIN_OPTIONS);
                sessionStorage.removeItem(jyxRtcConstants.JYX_RTC_JOIN_ROOM_OPTIONS);
                this.rtcEngine.destroy();
            }
            this.$router.push({path: "/" + path, query: query});
        },
        init() {
            console.log("init");
            this.rtcEngine = init();
        },
        getOnlineUsers(isRefresh) {
            console.log("getOnlineUsers ");
            this.rtcEngine.getOnlineUsers()
                .then((users) => {
                    console.log("getOnlineUsers success", users);
                    // 去除自身
                    let item = null;
                    for (let i = 0; i < users.length; i++) {
                        item = users[i];
                        if (item.userId === this.jyxRtcLoginOptions.userId) {
                            users.splice(i--, 1);
                            break;
                        }
                    }

                    let onLineUserMapByUserId = new Map();
                    this.onlineUsers = users.map((user) => {
                        // userExtInfo为json串，需转换
                        user.userExtInfo = user.userExtInfo || JSON.stringify({userId: user.userId, userName: user.userId});
                        user.userExtInfo = JSON.parse(user.userExtInfo);
                        onLineUserMapByUserId.set(user.userId, user);
                        return user;
                    });
                    this.onLineUserMapByUserId = onLineUserMapByUserId;

                    if (isRefresh) {
                        this.checkedUsers = [];
                        this.checkAll = false;
                        this.isIndeterminate = false;
                        this.$message({
                            type: "success",
                            message: "重新获取在线用户列表成功!",
                            duration: 1500
                        });
                    } else {
                        // 去除无效的userId
                        let deleteFlag = true;
                        this.checkedUsers.forEach((checkedUser, index, array) => {
                            deleteFlag = true;
                            this.onlineUsers.forEach((onlineUser) => {
                                if (onlineUser.userId === checkedUser) {
                                    deleteFlag = false;
                                }
                            });
                            if (deleteFlag) {
                                array.splice(index, 1);
                            }
                        });
                        if (!this.checkedUsers.length) {
                            // 未选择
                            this.checkAll = false;
                            this.isIndeterminate = false;
                        } else if (this.checkedUsers.length === this.onlineUsers.length) {
                            // 全选
                            this.checkAll = true;
                            this.isIndeterminate = false;
                        } else {
                            // 部分选择
                            this.checkAll = false;
                            this.isIndeterminate = true;
                        }
                    }
                })
                .catch((error) => {
                    console.log("getOnlineUsers error", error);
                    showErrorMessage("获取在线用户列表失败", error);
                });
        },
        sendMessage(userMessage) {
            userMessage.sendState = 1;
            this.rtcEngine.sendMessage({userId: userMessage.targetUserId, message: userMessage.message})
                .then(() => {
                    console.log("sendMessage success");
                    this.message = "";
                    userMessage.sendState = 2;
                })
                .catch((error) => {
                    console.log("sendMessage error", error);
                    userMessage.sendState = 0;
                    showErrorMessage("消息发送失败", error);
                });
        },
        sendMessageHandle() {
            console.log("sendMessage ");
            if (!this.checkedUsers || !this.checkedUsers.length) {
                this.$message({
                    type: "error",
                    message: "至少选择一个发送对象!",
                    duration: 1500
                });
                return;
            }
            if (!this.message) {
                this.$message({
                    type: "error",
                    message: "发送内容不能为空!",
                    duration: 1500
                });
                return;
            }
            let userMessageList = [];
            this.checkedUsers.forEach((checkedUser) => {
                let user = this.onLineUserMapByUserId.get(checkedUser);
                user.userExtInfo = user.userExtInfo || JSON.stringify({userId: user.userId, userName: user.userId});
                userMessageList.push({
                    sourceUserId: this.jyxRtcLoginOptions.userId,
                    sourceUserExtInfo: JSON.parse(this.jyxRtcLoginOptions.userExtInfo),
                    targetUserId: checkedUser,
                    targetUserExtInfo: user.userExtInfo,
                    message: this.message,
                    sendState: 0,
                    time: new Date()
                });
            });
            this.userMessageList = this.userMessageList.concat(userMessageList);
            userMessageList.forEach((userMessage) => {
                this.sendMessage(userMessage);
            });
        },
        joinRoom(roomId, roomPassword) {
            roomId = roomId === undefined ? "" : roomId + "";
            roomPassword = roomPassword === undefined ? "" : roomPassword + "";
            let jyxRtcJoinRoomOptions = {roomId: roomId + "", roomPassword: roomPassword};
            console.log("joinRoom ", jyxRtcJoinRoomOptions);
            if (!jyxRtcJoinRoomOptions || !jyxRtcJoinRoomOptions.roomId) {
                this.$message({
                    type: "error",
                    message: "房间Id不能为空!",
                    duration: 1500
                });
                return;
            }
            this.rtcEngine.joinRoom(jyxRtcJoinRoomOptions.roomId, jyxRtcJoinRoomOptions.roomPassword)
                .then(() => {
                    console.log("joinRoom success");
                    sessionStorage.setItem(jyxRtcConstants.JYX_RTC_JOIN_ROOM_OPTIONS, JSON.stringify(jyxRtcJoinRoomOptions));
                    this.goto({path: "video-chat"});
                })
                .catch((error) => {
                    console.log("joinRoom error", error);
                    showErrorMessage("进入房间失败!", error);
                });
        },
        logout() {
            console.log("logout ");
            this.rtcEngine.logout()
                .then(() => {
                    console.log("logout success");
                    this.goto({path: "login"});
                })
                .catch((error) => {
                    console.log("logout error", error);
                    showErrorMessage("登出失败!", error);
                });
        },
        answerInvite(answer, inviteResult) {
            console.log("answerInvite ");
            this.rtcEngine.answerInvite({sourceUserId: inviteResult.sourceUserId, answer: answer})
                .then(() => {
                    console.log("answerInvite success");
                    if (answer === "1") {
                        this.joinRoom(inviteResult.roomId, inviteResult.roomPassword);
                    }
                })
                .catch((error) => {
                    console.log("answerInvite error", error);
                });
        },
        reloginHandle(jyxRtcLoginOptions) {
            this.$confirm("连接断开，是否重新登录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    console.log("login");
                    this.rtcEngine.login(jyxRtcLoginOptions)
                        .then(() => {
                            console.log("login success");
                            this.$message({
                                type: "success",
                                message: "登录成功!",
                                duration: 1500
                            });
                            this.getOnlineUsers();
                        })
                        .catch((error) => {
                            console.log("login error", error);
                            showErrorMessage("登录失败!", error);
                            this.goto({path: "login"});
                        });
                })
                .catch(() => {
                    this.goto({path: "login"});
                });
        },
        onDisconnectHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_DISCONNECT, result);
            this.$confirm("连接异常，将跳转至登录页，请确认", "提示", {
                confirmButtonText: "确定",
                type: "error",
                showClose: false,
                showCancelButton: false
            })
                .then(() => {
                    this.goto({path: "login"});
                })
                .catch(() => {
                    this.goto({path: "login"});
                });
        },
        onReceiveMessageHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_RECEIVE_MESSAGE, result);
            result.sourceUserExtInfo = result.sourceUserExtInfo || JSON.stringify({userId: result.userId, userName: result.userId});
            let userMessage = {
                sourceUserId: result.sourceUserId,
                sourceUserExtInfo: JSON.parse(result.sourceUserExtInfo),
                targetUserId: this.jyxRtcLoginOptions.userId,
                targetUserExtInfo: JSON.parse(this.jyxRtcLoginOptions.userExtInfo),
                message: result.message,
                sendState: 2,
                time: new Date()
            };
            this.userMessageList.push(userMessage);
        },
        onInviteHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_INVITE, result);
            result.sourceUserExtInfo = result.sourceUserExtInfo || JSON.stringify({userId: result.userId, userName: result.userId});
            let userExtInfo = JSON.parse(result.sourceUserExtInfo);
            let h = this.$createElement;
            let notify = this.$notify.info({
                title: "消息",
                dangerouslyUseHTMLString: true,
                duration: 0,
                message: (h("p",
                    [
                        h("span", {
                            style: "color: #5daf34; font-size: 24px"
                        }, userExtInfo.userName),
                        h("span", null, "邀请你进入"),
                        h("span", {
                            style: "color: #5daf34; font-size: 24px"
                        }, result.roomId),
                        h("span", null, "房间"),
                        h("br", null, null),
                        h("el-button", {
                            on: {
                                click: () => {
                                    this.answerInvite("0", result);
                                    notify.close();
                                }
                            }
                        }, "拒绝"),
                        h("el-button", {
                            on: {
                                click: () => {
                                    this.answerInvite("1", result);
                                    notify.close();
                                }
                            }
                        }, "同意"),
                        h("el-button", {
                            on: {
                                click: () => {
                                    this.answerInvite("2", result);
                                    notify.close();
                                }
                            }
                        }, "关闭")
                    ]
                )),
                showClose: false
            });
        },
        onInviteAnswerHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_INVITE_ANSWER, result);
            result.targetUserExtInfo = result.targetUserExtInfo || JSON.stringify({userId: result.userId, userName: result.userId});
            let userExtInfo = JSON.parse(result.targetUserExtInfo);
            let h = this.$createElement;
            if (["0", "1"].indexOf(result.answer) !== -1) {
                this.$notify.info({
                    title: "消息",
                    dangerouslyUseHTMLString: true,
                    message: (h("p",
                        [
                            h("span", {
                                style: "color: #5daf34; font-size: 24px"
                            }, userExtInfo.userName),
                            h("span", {
                                style: result.answer === "1" ? "color: blue; font-size: 36px" : "color: red; font-size: 32px"
                            }, result.answer === "1" ? " 接受了 " : " 拒绝了 "),
                            h("span", null, "你的邀请")
                        ]
                    ))
                });
            }
        },
        onLoginHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_LOGIN, result);
            result.userExtInfo = result.userExtInfo || JSON.stringify({userId: result.userId, userName: result.userId});
            let userExtInfo = JSON.parse(result.userExtInfo);
            this.getOnlineUsers();
            let h = this.$createElement;
            this.$notify.info({
                title: "消息",
                dangerouslyUseHTMLString: true,
                message: (h("p",
                    [
                        h("span", {
                            style: "color: #5daf34; font-size: 24px"
                        }, userExtInfo.userName),
                        h("span", null, "已"),
                        h("span", {
                            style: "color: #5daf34; font-size: 24px"
                        }, "上线")
                    ]
                ))
            });
        },
        onLogoutHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_LOGOUT, result);
            result.userExtInfo = result.userExtInfo || JSON.stringify({userId: result.userId, userName: result.userId});
            let userExtInfo = JSON.parse(result.userExtInfo);
            this.getOnlineUsers();
            let item = null;
            for (let i = 0; i < this.checkedUsers.length; i++) {
                item = this.checkedUsers[i];
                if (item === result.userId) {
                    this.checkedUsers.splice(i--, 1);
                    break;
                }
            }
            let h = this.$createElement;
            this.$notify.info({
                title: "消息",
                dangerouslyUseHTMLString: true,
                message: (h("p",
                    [
                        h("span", {
                            style: "color: red; font-size: 24px"
                        }, userExtInfo.userName),
                        h("span", null, "已"),
                        h("span", {
                            style: "color: red; font-size: 24px"
                        }, "下线")
                    ]
                ))
            });
        },
        unSubscribeEventHandle() {
        //  取消订阅
            for (let key in eventNameConstants) {
                this.rtcEngine.unSubscribeEvent(eventNameConstants[key]);
            }
        },
        subscribeEventHandle() {
            // 取消订阅
            this.unSubscribeEventHandle();
            // 收到连接断开消息
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_DISCONNECT, this.onDisconnectHandle);
            // 收到用户消息
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_RECEIVE_MESSAGE, this.onReceiveMessageHandle);
            // 收到呼叫邀请
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_INVITE, this.onInviteHandle);
            // 收到呼叫回复
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_INVITE_ANSWER, this.onInviteAnswerHandle);
            // 用户登录
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_LOGIN, this.onLoginHandle);
            // 用户登出
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_LOGOUT, this.onLogoutHandle);
        },
        handleCheckAllChange(val) {
            this.checkedUsers = val ? this.onlineUsers.map((onlineUser) => onlineUser.userId) : [];
            this.isIndeterminate = false;
        },
        handleCheckedUsersChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.onlineUsers.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.onlineUsers.length;
        },
        dateFormat(value, format = "YYYY-MM-DD HH:mm:ss") {
            return Moment(value)
                .format(format);
        }
    }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .message-chat {
    .el-checkbox {
      margin-left: 20px;
      .el-checkbox__input {
        float: left;
      }
    }
  }

</style>
